import { useQuery } from '@tanstack/react-query';
import { budgetService } from '@services/budget';
import { PAGINATED_BUDGET_REQUESTS_QUERY_KEY } from './usePaginatedBudgetRequests';

export const BUDGET_REQUEST_DETAILS_QUERY_KEY = 'budget-request-details';

export const useBudgetRequestDetails = (
  budgetRequestId: string | undefined,
) => {
  return useQuery({
    queryKey: [
      BUDGET_REQUEST_DETAILS_QUERY_KEY,
      PAGINATED_BUDGET_REQUESTS_QUERY_KEY,
      budgetRequestId,
    ],
    queryFn: () => budgetService.getBudgetRequestDetails(budgetRequestId!),
    enabled: !!budgetRequestId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
